import { TypeProcess } from '../../interfaces/TypeProcess/TypeProcess'
import {
  GET_TYPE_PROCESS,
  GET_TYPE_PROCESS_EXITO
} from '../types/typeProcessActionsTypes'

export type TypeProcessAction = TypesProcessAction | TypesProcessActionAsync

// Esto va a REDUX
export interface TypesProcessAction {
  type: typeof GET_TYPE_PROCESS_EXITO
  typeProcess: TypeProcess[] | undefined
  error: string | undefined
}

export const getTypeProcessAction = (
  typeProcess?: TypeProcess[],
  error?: string
): TypesProcessAction => {
  return {
    type: GET_TYPE_PROCESS_EXITO,
    typeProcess,
    error
  }
}

// Esto va a SAGA
export interface TypesProcessActionAsync {
  type: typeof GET_TYPE_PROCESS
}

export const getTypeProcessActionAsync = (): TypesProcessActionAsync => {
  return {
    type: GET_TYPE_PROCESS
  }
}
